export default __webpack_public_path__ + "static/media/icon-gear.345f5456.svg";